import { initReactI18next } from 'react-i18next';
import { getEnvConfig } from '@configs/env';
import i18n from 'i18next';
import { loadTranslationResources, createCompanyTranslations } from './translationLoader';

// 기본 초기화
const { COMPANY_ID, CUSTOM_TRANSLATION, MODE } = getEnvConfig();

/**
 * 환경변수 기반 i18n 초기화 함수
 */
export const initializeI18n = async (companyId: CompanyType, enableCustomTranslation: string) => {
  // 1. 기본 번역 리소스 로드
  const baseResources = loadTranslationResources();

  try {
    // 2. 회사별 번역 오버라이드 적용
    const { resources, language } = createCompanyTranslations(baseResources, companyId, enableCustomTranslation);

    // 3. i18n 초기화
    await i18n.use(initReactI18next).init({
      resources,
      lng: language,
      fallbackLng: 'ko',
      supportedLngs: ['ko', 'en'],
      interpolation: {
        escapeValue: false,
      },
      // 개발 모드에서 디버깅 정보 표시
      debug: MODE === 'development' && CUSTOM_TRANSLATION === 'true',
    });
  } catch (error) {
    console.error('Failed to initialize i18n:', error);

    // 폴백: 기본 설정으로 초기화
    await i18n.use(initReactI18next).init({
      resources: baseResources,
      lng: 'ko',
      fallbackLng: 'ko',
      supportedLngs: ['ko', 'en'],
      interpolation: {
        escapeValue: false,
      },
    });
  }
};

initializeI18n(COMPANY_ID, CUSTOM_TRANSLATION);

export default i18n;
